var _StyleRegistry=require('./StyleRegistry');var _StyleRegistry2=_interopRequireDefault(_StyleRegistry);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}
var registry=new _StyleRegistry2.default();
module.exports=registry;


// WEBPACK FOOTER //
// ./~/react-native-web/dist/apis/StyleSheet/registry.js